import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "antd";
import Widget from "../../../../../../components/Widget";
import style from "./LeftWidget.module.scss";
import { getRightAnswerCount } from "../../utils";
import _ from "underscore";
import {
    toFixedNumber,
    getQuestionTypeName,
    QuestionType
} from "../../../../../../service/service";
import GoBackButton from "pages/homework/component/goBackButton";
import { StuTopics } from "service/homework";
import Decimal from "decimal.js";

// import moment from 'moment'

interface ILeftWidgetProps {
    courseName: string;
    stuName: string;
    homeworkTime: string;
    list: StuTopics[];
    paperName?: string; //试卷名
}

export default function LeftWidget({
    courseName,
    stuName,
    homeworkTime,
    list,
    paperName
}: ILeftWidgetProps) {
    const [infoList, setInfoList] = useState<any[]>([]);

    useEffect(() => {
        const data = _.chain(list)
            .groupBy("type")
            .map((list, type) => {
                return getGroupExamScore(list, type as unknown as QuestionType);
            })
            .value();
        setInfoList(data);
    }, [list]);

    const getGroupExamScore = (topics: StuTopics[], type: QuestionType) => {
        let score = 0,
            count: string | number = "-";
        switch (type) {
            case QuestionType.DanXuan:
            case QuestionType.DuoXuan:
            case QuestionType.PanDuan:
                let data = getRightAnswerCount(topics, type);
                score = data.score;
                count = data.count;
                break;
            case QuestionType.TianKong:
                count = "-";
                score = _.reduce(
                    topics,
                    (prev, topic) => {
                        return (
                            prev +
                            _.reduce(
                                topic.answers,
                                (prev, answer) => {
                                    const content = answer.content?.replace(
                                        /\s*/g,
                                        ""
                                    );
                                    const stuAnswer = answer.stuAnswer?.replace(
                                        /\s*/g,
                                        ""
                                    );
                                    if (content === stuAnswer) {
                                        return (
                                            prev +
                                            parseFloat(topic.score) /
                                                topic.answers.length
                                        );
                                    } else {
                                        return prev;
                                    }
                                },
                                0
                            )
                        );
                    },
                    0
                );
                break;
            case QuestionType.ZhuGuan:
                count = "-";
                score = _.reduce(
                    topics,
                    (memo, item) =>
                        parseFloat(item.markScore)
                            ? memo + parseFloat(item.markScore)
                            : memo,
                    0
                );
                break;
            case QuestionType.TingLi:
            case QuestionType.WanXingTianKong:
            case QuestionType.YueDuLiJie:
                count = "-";
                score = _.chain(topics)
                    .map(topic => {
                        return _.chain(topic.topics)
                            .groupBy("type")
                            .map((topic, type) => {
                                return getGroupExamScore(
                                    topic,
                                    type as unknown as QuestionType
                                );
                            })
                            .reduce(
                                (prev, curr) =>
                                    prev +
                                    ((curr.score as unknown as number) || 0),
                                0
                            )
                            .value();
                    })
                    .reduce((prev, curr) => prev + curr, 0)
                    .value();
                break;
            default:
                break;
        }
        return { type, all: topics.length, correct: count, score };
    };

    const totalScores = useMemo(() => {
        return _.reduce(
            infoList,
            function (memo, num) {
                const _memo = new Decimal(memo);
                const _score = new Decimal(num.score);
                return _memo.add(_score).toNumber();
            },
            0
        );
    }, [infoList]);

    return (
        <Widget title="判卷" bodyPadding extraTools={<GoBackButton />}>
            <div className={style.root}>
                <Row className={style.item}>
                    <Col span={24} className={style.label}>
                        课程：{courseName}
                    </Col>
                </Row>
                {paperName && (
                    <Row className={style.item}>
                        <Col span={24}>
                            <span className={style.label}>试卷：</span>
                            {paperName}
                        </Col>
                    </Row>
                )}
                <Row className={style.item}>
                    <Col span={24}>
                        <span className={style.label}>姓名：</span>
                        {stuName}
                    </Col>
                </Row>
                <Row className={style.item}>
                    <Col span={24}>
                        <span>时间：</span>
                        {homeworkTime}
                    </Col>
                </Row>
            </div>

            <div className={style.padding}>
                <h2 className={style.totalScore}>
                    总分：
                    {totalScores}分
                </h2>

                <table className={style.table}>
                    <tbody>
                        <tr>
                            <th>题目</th>
                            <th>得分</th>
                        </tr>
                        {infoList.map((item: any, index: any) => (
                            <tr key={index}>
                                <td>{getQuestionTypeName(item.type)}</td>
                                <td>{toFixedNumber(item.score)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Widget>
    );
}
